import React from 'react';
import EquipmentForm from '../../equipmentSurveys/components/EquipmentForm';
import { BasicInfo, CurrentPractices } from './components/';
import {
  ReplacementAssessment,
  NewEquipment,
  PurchasingDecision
} from '../components';

function BuildingHeat({ applicationData, setApplicationData }) {
  return (
    <EquipmentForm
      applicationData={applicationData}
      setApplicationData={setApplicationData}
    >
      <BasicInfo />
      <CurrentPractices />
      <ReplacementAssessment />
      <NewEquipment />
      <PurchasingDecision />
    </EquipmentForm>
  );
}

export default BuildingHeat;
